import React, { useEffect, useRef } from "react";
import { urlVarsHelper } from "../../../helpers/urlVarsHelper";
import { Loading } from "../Loading";
import { RootState, Session } from "../../../store/config/types";
import { ThunkDispatch } from "redux-thunk";
import { AppActions } from "../../../store/config/ActionTypes";
import { fetchPurchaseData, pageRedirect } from "../../../store/action_creators/purchases.actions";
import { ConnectedProps, connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { PaymentStatusEnum } from "../../../store/config/enums";

const mapStateToProps = (state: RootState) => ({
  purchases: state.purchases,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, AppActions>) => ({
  pageRedirect: (sessionId: string) => dispatch(pageRedirect(sessionId)),
  fetchPurchaseData: ({ sessionId }: Session) => dispatch(fetchPurchaseData({ sessionId })),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

function Redirect({ purchases, pageRedirect, fetchPurchaseData }: PropsFromRedux) {
  const hasTriggeredRedirect = useRef(false);
  const hasTriggeredPurchaseLoad = useRef(false);
  const lastSessionId = useRef<string | null>(null);

  const history = useHistory();
  const urlVars = urlVarsHelper.getUrlVars();
  const sessionId = urlVars.sessionId;
  const hasError = Boolean(urlVars.errorcode || urlVars.errorCode);

  useEffect(() => {
    if (hasError) {
      history.replace("/error/?errorCode=4");
      return;
    }

    if (!sessionId) {
      history.replace("/error?errorCode=6");
      return;
    }

    if (lastSessionId.current !== sessionId) {
      lastSessionId.current = sessionId;
      hasTriggeredRedirect.current = false;
      hasTriggeredPurchaseLoad.current = false;
    }

    if (
      !hasTriggeredPurchaseLoad.current &&
      !purchases.loadingPurchaseData &&
      purchases.purchaseData === null &&
      purchases.loadPurchaseDataError === null
    ) {
      hasTriggeredPurchaseLoad.current = true;
      fetchPurchaseData({ sessionId });
    }

    if (!hasTriggeredRedirect.current) {
      hasTriggeredRedirect.current = true;
      pageRedirect(sessionId);
    }
  }, [
    history,
    hasError,
    sessionId,
    purchases.loadingPurchaseData,
    purchases.purchaseData,
    purchases.loadPurchaseDataError,
    fetchPurchaseData,
    pageRedirect,
  ]);

  useEffect(() => {
    if (purchases.loadPurchaseDataError) {
      history.push("/error?errorCode=99");
    }
  }, [history, purchases.loadPurchaseDataError]);

  useEffect(() => {
    if (
      purchases.purchaseSuccess &&
      purchases.transactionCallbackResponse?.status !== PaymentStatusEnum.PENDING
    ) {
      history.push(`/result?isCard=${!purchases.transactionCallbackResponse?.notACard}`)
    }

    if (purchases.purchaseError !== null) {
      history.push(
        purchases.transactionCallbackResponse?.notACard
          ? '/error?errorCode=8'
          : '/error?errorCode=3'
      )
    }
  }, [
    history,
    purchases.purchaseSuccess,
    purchases.purchaseError,
    purchases.transactionCallbackResponse
  ]);

  return <Loading dark={false} />;
}

export default connector(Redirect);